import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";
import { busca_detalhe_lancamento } from "../../services/api";
import { ConverteSerie, ConverteSegmentoSig, ordem } from "./modulo";

const Detalhe_lancamento = (props) => {
    const [data2, setData2] = useState([]);

    let cod_unidade = props.un;
    let avaliacao = props.av;
    let serie = props.se;

    const fetchData = async () => {
        try {
            const response = await busca_detalhe_lancamento(avaliacao, cod_unidade, serie);
            console.log("RES=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [avaliacao, serie]);

    let chartDatSerie = [];

    if (typeof data2 !== 'undefined') {
        chartDatSerie = data2.map((item, index) => {
            const row = [item.turma];
            row.push(parseInt(item.alunos));
            row.push(item.dsc);
            row.push(parseInt(item.notas) || '');
            if (parseFloat(item.perc) < 100) {
                row.push(parseFloat(item.perc));
            } else {
                row.push(100.0);
            };


            row.push(item.professor);
            row.push(item.dtf);
            return row;
        });
    };

    chartDatSerie.sort();
    chartDatSerie.unshift(["Turma", "Qtd Alunos", "Disciplina", "Qtd Notas", "%", "Professor", "Prazo"]);

    const options = {
        allowHtml: true,
    };

    const formatters = [
        {
            type: "NumberFormat",
            column: 4,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 30, "white", "darkred"],
                [30, 50, "white", "red"],
                [50, 70, "white", "orange"],
                [70, 100, "black", "lightgreen"],
                [100, 101, "white", "blue"],
            ],
        },
    ];

    return (
        <div className="LancamentoDetalhe" style={{ border: "1px solid #ccc", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <center>
                <h5><b>
                    Detalhamento de lançamento por série e avaliação
                </b>
                </h5>
            </center>
            <br />
            <Chart
                chartType="Table"
                width="100%"
                data={chartDatSerie}
                options={options}
                formatters={formatters}
            />
        </div>
    );
};

export default Detalhe_lancamento;
